<template>
    <div>
        <v-select 
            @search="getOptions"
            :options="options" 
            :label="label" 
            :filterable="false"
            @input="selected"
            :reduce="option => option.id"
            :value="inputValue"
        >
            <li slot="list-footer" class="pagination" v-if="pagination.pages > 1">
                <button @click="previous()" :disabled="pagination.page == 1"><</button>
                <button @click="next()" :disabled="pagination.page >= pagination.pages">></button>
            </li>
            <div slot="spinner" v-show="loading">
                <loader class='ml-3' :width="'30px'" :thickness="'7px'"></loader>
            </div>
        </v-select>
    </div>
</template>

<script>
import Loader from './Loader'
import _ from "lodash";
export default {
  data: () => ({
    loading: false,
    options: [],
    filtersCounter: [],
    pagination: {
        count: 0,
        filter: 0,
        page: 1,
        pages: 0,
        search: ''
    }
  }),
  methods: {
    selected(value){
        this.$emit('selected', value)
    },
    getOptions(){},
    next(){
        this.pagination.page ++
        this.getOptions(this.pagination.search, false)
    },
    previous(){
        this.pagination.page --
        this.getOptions(this.pagination.search, false)
    }
  },
  props: [
    'entity',
    'label',
    'entityFilters',
    'inputValue'
  ],
  watch: {
    entityFilters: {
      deep: true,
      handler(){
        this.getOptions()
      }
    }
  },
  computed: {
    endpoint() {
      return this.$store.getters.api + this.entity
    },
    hasNextPage() {
      return true
    },
    hasPrevPage() {
      return true
    }
  },
  mounted(){
    this.getOptions = _.debounce((search, resetPagination = true) => {
        const self = this
        self.loading = true
        if(resetPagination){
            self.pagination.page = 1
            self.pagination.search = ''
        }
        let endpoint = self.endpoint + '?limit=10&page=' + self.pagination.page
        if(search){
            endpoint += '&' + self.label + '=' + search
        }
        if(self.entityFilters && self.entityFilters.length){
          self.entityFilters.forEach(filter => {
            let alreadyUsedFilter = self.filtersCounter[filter.column] ? true : false
            if(filter.value){
              if(!filter.onlyFirst || (filter.onlyFirst && !alreadyUsedFilter)){
                endpoint += '&' + filter.column + '=' + filter.value
                self.filtersCounter[filter.column] = self.filtersCounter[filter.column] ?  self.filtersCounter[filter.column]++ : 1
              }
              //  else if(filter.onlyFirst && !alreadyUsedFilter){
              //   self.inputValue = null
              // }
            }
          })
        }
        axios.get(endpoint)
            .then(r => {
                self.options = r.data.data
                self.pagination = {
                    count: r.data.count,
                    filter: r.data.filter,
                    page: r.data.page + 1,
                    pages: r.data.pages,
                    search: search
                }
                self.loading = false
            }).catch(x => {
                self.$message('Erro', x.response.data || x, 'error')
                self.loading = false
            })
    }, 800),
    this.getOptions()
  },
  components: {
      Loader
  }
};
</script>
<style scoped>
  .pagination {
    margin: 1rem .25rem 0;
  }
  .pagination button:nth-child(2) {
    margin-left: auto;
  }
  .pagination button:hover {
    cursor: pointer;
  }
  .pagination button{
    border-radius: 10px;
    height: 40px;
    background-color: #cccccc;
    color: black;
    border: 2px solid black;
    width: 48%
  }
  .pagination button:disabled{
    background-color: #f2f2f2 !important;
    color: #333333 !important;
    border: 2px solid lightgray !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/Utils/VSelectDefault.vue